/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Precision of a chronology event date
 */
export type DatePrecision = typeof DatePrecision[keyof typeof DatePrecision];


export const DatePrecision = {
  DAY: 'DAY',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  UNKNOWN: 'UNKNOWN',
} as const;
